import React from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import "../components/homePreview/homePreview.css";
import HomePreviewHeader from "../components/homePreview/HomePreviewHeader.jsx";
import HomePreviewHero from "../components/homePreview/HomePreviewHero.jsx";
import HomePreviewServices from "../components/homePreview/HomePreviewServices.jsx";
import HomePreviewConversion from "../components/homePreview/HomePreviewConversion.jsx";
import HomePreviewGallery from "../components/homePreview/HomePreviewGallery.jsx";
import HomePreviewTrust from "../components/homePreview/HomePreviewTrust.jsx";
import HomePreviewCta from "../components/homePreview/HomePreviewCta.jsx";
import HomePreviewSeoFooter from "../components/homePreview/HomePreviewSeoFooter.jsx";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "DecorZoom",
  url: "https://www.decorzoom.in",
  telephone: "+91-8377982191",
  image: "https://www.decorzoom.in/images/logo.png",
  logo: "https://www.decorzoom.in/images/logo.png",
  priceRange: "$$",
  areaServed: ["Delhi", "Noida", "Ghaziabad", "Gurgaon", "Faridabad"].map((cityName) => ({
    "@type": "City",
    name: cityName,
  })),
};

export default function HomePagePreview() {
  return (
    <div className="font-body min-h-screen overflow-x-hidden bg-zoom-warm text-zoom-charcoal antialiased">
      <title>DecorZoom - Balloon &amp; Event Decorations in Delhi NCR</title>
      <meta
        name="description"
        content="Book balloon decorations, baby showers, birthday setups, banquet booking and event decor in Delhi, Noida, Ghaziabad, Gurgaon and Faridabad. Professional customized services by DecorZoom."
      />
      <link rel="canonical" href="https://www.decorzoom.in/" />
      <meta property="og:title" content="DecorZoom - Balloon & Event Decorations in Delhi NCR" />
      <meta
        property="og:description"
        content="Book stunning balloon and birthday decorations, banquet halls, and event decor for kids parties and celebrations across Delhi NCR."
      />
      <meta property="og:image" content="https://www.decorzoom.in/images/logo.png" />
      <meta property="og:url" content="https://www.decorzoom.in/" />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <HomePreviewHeader />
      <HomePreviewHero />

      <HomePreviewServices />
      <HomePreviewConversion />
      <HomePreviewGallery />
      <HomePreviewTrust />
      <HomePreviewCta />
      <HomePreviewSeoFooter />

      <motion.a
        href="https://wa.me/918377982191"
        target="_blank"
        rel="noreferrer"
        initial={{ opacity: 0, scale: 0.6, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="fixed bottom-5 left-4 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-xl text-white shadow-hp-md ring-4 ring-white/80 sm:bottom-6 sm:left-6"
        aria-label="WhatsApp DecorZoom"
      >
        <FaWhatsapp />
      </motion.a>
      <motion.a
        href="tel:+918377982191"
        initial={{ opacity: 0, scale: 0.6, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="fixed bottom-5 right-4 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-zoom-emeraldDeep text-lg text-white shadow-hp-md ring-4 ring-white/80 sm:bottom-6 sm:right-6"
        aria-label="Call DecorZoom"
      >
        <FaPhoneAlt />
      </motion.a>
    </div>
  );
}
